export default __webpack_public_path__ + "static/media/javascript-logo.fd46ca41.svg";